"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const useDonations_1 = __importDefault(require("../../../hooks/useDonations"));
const ShareButtons = ({ award, color }) => {
    const [, setShowNotification] = react_1.default.useState(false);
    const { refetch } = (0, useDonations_1.default)();
    (0, react_1.useEffect)(() => {
        // TODO remove kind of award if not needed
    }, [award]);
    const handleRefetch = () => __awaiter(void 0, void 0, void 0, function* () {
        yield refetch();
    });
    const createShareAward = () => {
        if (!(award === null || award === void 0 ? void 0 : award.isLatest)) {
            return;
        }
        axios_1.default
            .post('/api/add-action', {
            key: `share-${award === null || award === void 0 ? void 0 : award.key}`,
            id: 3,
        })
            .then((res) => {
            if (res.data.notify === true) {
                handleRefetch();
                setShowNotification(true);
                //TODO add notification
            }
        })
            .catch((err) => {
            err.log(err);
        });
    };
    if (!award) {
        return null;
    }
    const shareImgUrl = () => {
        // Get current timestamp
        const timestamp = new Date().getTime();
        // Add timestamp as query parameter to avoid caching
        return window.location.origin + '/card/' + award.card + '?' + timestamp;
    };
    const shareUrl = (type) => {
        const image = shareImgUrl();
        let url = '';
        switch (type) {
            case 'facebook':
                url = 'https://www.facebook.com/sharer/sharer.php?u=' + image;
                break;
            case 'linkedin':
                url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + image;
                break;
            default:
                break;
        }
        return url;
    };
    return ((0, jsx_runtime_1.jsxs)("div", { id: "share-buttons", children: [(0, jsx_runtime_1.jsxs)("span", { className: "share-text", style: { color: '#212529' }, "aria-hidden": "true", children: [' ', __.trans('awards.share')] }), (0, jsx_runtime_1.jsx)("div", { className: "icon-wrapper", style: { backgroundColor: color !== null && color !== void 0 ? color : '#000' }, children: (0, jsx_runtime_1.jsx)("a", { href: shareUrl('facebook'), target: "_blank", rel: "noreferrer", onClick: createShareAward, "aria-label": __.trans('aria.share-facebook'), children: (0, jsx_runtime_1.jsx)("i", { className: "icon icon-facebook" }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "icon-wrapper", style: { backgroundColor: color !== null && color !== void 0 ? color : '#000' }, children: (0, jsx_runtime_1.jsx)("a", { href: shareUrl('linkedin'), target: "_blank", rel: "noreferrer", onClick: createShareAward, "aria-label": __.trans('aria.share-linkedin'), children: (0, jsx_runtime_1.jsx)("i", { className: "icon icon-linkedin" }) }) })] }));
};
exports.default = ShareButtons;
